// Mount the platform-provided logout route at /logout.
// The platform's loader calls logoutFn and redirects to /login, so the
// page itself never renders; the old placeholder UI is gone.

import { logoutRoute } from '@podium/platform/routes'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/logout')(logoutRoute)
